import { render, staticRenderFns } from "./AnswerDetails.vue?vue&type=template&id=3ef3e2ea&scoped=true&"
import script from "./AnswerDetails.vue?vue&type=script&lang=js&"
export * from "./AnswerDetails.vue?vue&type=script&lang=js&"
import style0 from "./AnswerDetails.vue?vue&type=style&index=0&id=3ef3e2ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef3e2ea",
  null
  
)

export default component.exports